module.exports = __webpack_public_path__ + "img/RScout64_ua.546ceca1.webp";